// src/components/dashboard/DashboardArcaniumPurchases.js
// eslint-disable-next-line no-unused-vars
import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';
import {getArcaniumPurchase} from '../../../api/axios';
import { useAuth } from '../../../hooks/useAuth';
import { Navigate} from 'react-router-dom';

const DashboardArcaniumPurchases = () => {
  const {t} = useTranslation();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const {user } = useAuth();


  useEffect(() => {
    const timer = setTimeout(() => {
      getArcaniumPurchase()
        .then(response => {
          let data = response.data;
          // Falls die API-Daten kein Array liefern, in ein Array umwandeln
          if (!Array.isArray(data)) {
            data = Object.values(data);
          }
          setLogs(data);
          setLoading(false);
        })
        .catch(error => {
          console.error('Error fetching arcanium purchases:', error);
          setLoading(false);
        });
    }, 1000); // 1000ms Delay

    return () => clearTimeout(timer);
  }, []);

  const totalPages = Math.ceil(logs.length / itemsPerPage);
  const currentLogs = logs.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


  if (!user) {
    return <Navigate to="/" replace />;
  }

  return (
    <Container>
      {loading ? (
        <p>{t('dashboardArcanium.loading')}</p>
      ) : logs.length === 0 ? (
        <p>{t('dashboardArcanium.noPurchases')}</p>
      ) : (
        <>
          <Summary>
            <SummaryText>{t('dashboardArcanium.totalPurchases', {count: logs.length})}</SummaryText>
          </Summary>
          <StyledTable>
            <thead>
              <tr>
                <Th>{t('dashboardArcanium.th.amount')}</Th>
                <Th>{t('dashboardArcanium.th.arcanium')}</Th>
                <Th>{t('dashboardArcanium.th.date')}</Th>
              </tr>
            </thead>
            <tbody>
              {currentLogs.map((log, index) => (
                <tr key={index}>
                  <Td>{(log.amount / 100).toFixed(2)} €</Td>
                  <Td>{log.arcanium.toLocaleString('de-DE')}</Td>
                  <Td>{new Date(log.created_at).toLocaleString()}</Td>
                </tr>
              ))}
            </tbody>
          </StyledTable>
          <PaginationContainer>
            <PageButton onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage <= 1}>
              {t('dashboardArcanium.prev')}
            </PageButton>
            <PageIndicator>{t('dashboardArcanium.pageIndicator', {currentPage, totalPages})}</PageIndicator>
            <PageButton onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage >= totalPages}>
              {t('dashboardArcanium.next')}
            </PageButton>
          </PaginationContainer>
        </>
      )}
    </Container>
  );
};

export default DashboardArcaniumPurchases;
const Container = styled.div`
  padding: 20px;
  @media (max-width: 600px) {
    padding: 10px;
  }
`;

const Summary = styled.div`
  margin-bottom: 10px;
  font-weight: bold;
  text-align: right;
  @media (max-width: 600px) {
    text-align: center;
  }
`;

const SummaryText = styled.span``;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 15px;
  text-align: center;
  @media (max-width: 600px) {
    font-size: 0.9rem;
  }
`;

const Th = styled.th`
  border-bottom: 2px solid #ddd;
  padding: 10px;
  @media (max-width: 600px) {
    padding: 8px;
  }
`;

const Td = styled.td`
  border-bottom: 1px solid #ddd;
  padding: 10px;
  @media (max-width: 600px) {
    padding: 8px;
  }
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  @media (max-width: 600px) {
    flex-direction: column;
    gap: 5px;
  }
`;

const PageButton = styled.button`
  padding: 6px 12px;
  border: none;
  background-color: #333;
  color: #fff;
  cursor: pointer;
  border-radius: 4px;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  @media (max-width: 600px) {
    width: 100%;
  }
`;

const PageIndicator = styled.span`
  font-weight: bold;
  @media (max-width: 600px) {
    font-size: 0.9rem;
  }
`;
